// No navegador não há acesso ao relógio: os números chegam pelo celular (sincronizados na conta) ou digitados.
export type SituacaoRelogio = 'pronto' | 'desconectado' | 'sem-app-novo' | 'instalar-hc' | 'sem-suporte';
export const fonteDoAparelho = () => 'Health Connect';
export const LINK_HC = 'https://play.google.com/store/apps/details?id=com.google.android.apps.healthdata';
export const situacaoRelogio = async (): Promise<SituacaoRelogio> => 'sem-suporte';
export const conectarRelogio = async () => false;
export const desconectarRelogio = async () => {};
export const abrirAjustesSaude = () => {};
export const sincronizarRelogio = async (_forcar = false, _dias = 7) => false;
